module.exports = __webpack_public_path__ + "static/media/pet_lvl1.2f8aa37c.png";